import React from 'react';
import {
  Box,
  Button,
  CircularProgress,
  useMediaQuery,
} from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import classnames from 'classnames';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import { MOBILE_TOOLBAR_TOTAL } from './constants';
import SaveIcon from '@material-ui/icons/Save';
import DeleteIcon from '@material-ui/icons/Delete';

export interface FormToolbarProps {
  onGoBack: () => void;
  onSave?: () => void;
  onDelete?: () => void;
  saveDisabled?: boolean;
  saveLoading?: boolean;
  showSave?: boolean;
  showDelete?: boolean;
  deleteLoading?: boolean;
}

export const FormToolbar = ({
  onGoBack,
  onSave,
  onDelete,
  saveDisabled = false,
  saveLoading = false,
  showSave = true,
  showDelete = false,
  deleteLoading = false,
}: FormToolbarProps) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <>
      <Box
        className={classnames(classes.toolbar, {
          [classes.mobileToolbar]: isMobile,
        })}
      >
        <Button
          className={classes.goBackButton}
          variant="contained"
          color="primary"
          startIcon={<ChevronLeftIcon />}
          onClick={onGoBack}
        >
          Go Back
        </Button>

        {showDelete && onDelete && (
          <Button
            className={classes.deleteButton}
            variant="contained"
            startIcon={
              deleteLoading ? <CircularProgress size={16} /> : <DeleteIcon />
            }
            onClick={onDelete}
            disabled={deleteLoading}
          >
            Delete
          </Button>
        )}
        {showSave && onSave && (
          <Button
            variant="contained"
            color="primary"
            startIcon={
              saveLoading ? (
                <CircularProgress size={16} color="inherit" />
              ) : (
                <SaveIcon />
              )
            }
            onClick={onSave}
            disabled={saveDisabled || saveLoading}
          >
            Save
          </Button>
        )}
      </Box>
      {isMobile && <div className={classes.spacer} />}
    </>
  );
};

const useStyles = makeStyles(theme => ({
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: theme.palette.grey[100],
    borderBottom: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(0.2, 3),
    minHeight: 64,
    marginTop: theme.spacing(2),
  },
  mobileToolbar: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    padding: theme.spacing(2),
    width: '100%',
    boxSizing: 'border-box',
    zIndex: theme.zIndex.appBar,
    backgroundColor: theme.palette.grey[100],
    border: 'none',
    marginTop: 0,
  },
  spacer: {
    height: MOBILE_TOOLBAR_TOTAL,
  },
  goBackButton: {
    marginRight: 'auto',
  },
  deleteButton: {
    marginRight: theme.spacing(2),
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.error.dark,
    },
  },
}));

export default FormToolbar;
export { MOBILE_TOOLBAR_TOTAL } from './constants';
